import { Pipe, PipeTransform } from '@angular/core';
import { normalizePackageDescriptionHtml } from '../utils/package-description.utils';

@Pipe({ name: 'packageDescription' })
export class PackageDescriptionPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return normalizePackageDescriptionHtml(value) || '';
  }
}
